var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefur2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_4035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_4035",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 73,
    height: 73
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66113 0.509766H74.4528V72.3848H2.66113V0.509766Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_4035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1872 54.2598H40.9476L18.1455 43.9629L14.6038 51.8171L20.0101 54.2598H14.0257C9.01009 54.2598 4.92676 50.0723 4.92676 44.9264V44.9212C4.92676 39.7754 9.01009 35.5879 14.0257 35.5879C19.0466 35.5879 23.1247 39.7754 23.1247 44.9264H25.3903V12.1087C25.3903 9.92643 24.8018 7.87956 23.7705 6.13477H72.1872V54.2598ZM58.7445 69.265L17.5986 50.6816L19.2809 46.9577L22.8695 48.5775L22.0257 50.4421L24.0934 51.3744L24.932 49.515L30.7809 52.1556L29.9424 54.015L32.0049 54.9473L32.8486 53.0879L38.6976 55.7285L37.8591 57.5931L39.9216 58.5254L40.7601 56.6608L46.6143 59.3066L45.7705 61.166L47.8382 62.0983L48.6768 60.2337L54.5257 62.8796L53.6872 64.7389L55.7497 65.6712L56.5934 63.8119L60.4268 65.541L58.7445 69.265ZM5.02051 12.1608C5.09342 11.3066 5.28092 9.75977 5.50488 9.0931C6.75488 5.31706 10.1976 2.77539 14.0726 2.77539C19.0674 2.77539 23.1247 6.96289 23.1247 12.1087V37.9837C21.0518 35.1556 17.7445 33.3223 14.0257 33.3223C10.3226 33.3223 7.02051 35.1452 4.94759 37.9525L5.02051 12.1608ZM74.4528 3.86914H22.0309C19.984 1.79102 17.1715 0.509766 14.0726 0.509766C9.21842 0.509766 4.91113 3.67122 3.35384 8.38477C2.96842 9.53581 2.78092 11.765 2.76009 12.0202L2.75488 12.0619L2.66113 44.9212C2.66113 44.9212 2.66113 44.9212 2.66113 44.9264C2.66113 51.3223 7.76009 56.5254 14.0257 56.5254H25.0309L59.8799 72.265L63.4216 64.4108L45.9684 56.5254H74.4528V3.86914Z",
    fill: "#151515"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7451 20.8132L46.568 13.2454L56.0524 20.8392V39.0319H52.1357V27.7194H41.6618V39.0319H37.7451V20.8132ZM35.4795 41.2975H43.9274V29.9902H49.8701V41.2975H58.318V19.7507L46.5212 10.3027L35.4795 19.7715V41.2975Z",
    fill: "#151515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6719 45.7812H65.8125V48.0469H67.6719V45.7812Z",
    fill: "#151515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3122 45.7812H59.6611V48.0469H64.3122V45.7812Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3122 49.4219H59.6611V51.6875H64.3122V49.4219Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6143 48.0469H51.5726V45.7812H36.6143V48.0469Z",
    fill: "#151515"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6143 8.97852H30.1299V11.2441H36.6143V8.97852Z",
    fill: "#151515"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_94_4035",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 58,
    width: 46,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.557617 58.9473H45.8337V73.5254H0.557617V58.9473Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_94_4035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9951 71.1771L40.2712 70.5313L40.7243 68.625L43.4482 69.2761L42.9951 71.1771ZM10.8337 61.5157L38.516 68.099L38.068 70.0052L10.3857 63.4219L10.8337 61.5157ZM8.51074 61.5052L8.30241 62.3854L7.16178 61.6511L8.51074 61.5052ZM44.3649 67.1615L39.042 65.8959L10.4222 59.0886C10.2243 59.0417 10.0264 59.0417 9.84408 59.0834L0.557617 60.0729L8.50033 65.2188C8.62533 65.3021 8.76595 65.3646 8.9222 65.4011L39.7451 72.7344L42.8649 73.4792C43.0107 73.5104 43.1566 73.5261 43.2972 73.5261C43.641 73.5261 43.9743 73.4323 44.2712 73.25C44.693 72.9896 44.9899 72.5834 45.1045 72.099L45.7451 69.4011C45.9847 68.4063 45.3649 67.4011 44.3649 67.1615Z",
    fill: "#151515"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_4035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefur2);
export default __webpack_public_path__ + "static/media/refur2.29d5a977a8a84b53f4aa3310ae1d6cc7.svg";
export { ForwardRef as ReactComponent };